export default "__VITE_ASSET__B6F2bIhw__"